export interface Category {
  id: string;
  name: string;
  url: string;
  image: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Bright%20white%20low-top%20sneakers%20with%20red%20accents%20floating%20above%20a%20pastel%20pink%20studio%20backdrop%20with%20soft%20drop%20shadows%2C%20vibrant%20product%20photography%2C%20clean%20modern%20editorial%20fashion%20shot%20with%20high%20detail&width=400&height=400&seq=cat-shoes&orientation=squarish&nocache=true',
  },
  {
    id: 'hoodies',
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20oversized%20hoodies%20in%20cream%20and%20sage%20green%20folded%20neatly%20on%20a%20rustic%20wooden%20table%20bathed%20in%20warm%20window%20light%2C%20soft%20fabric%20texture%2C%20cozy%20autumn%20lifestyle%20product%20photography%20with%20inviting%20tones&width=400&height=400&seq=cat-hoodies&orientation=squarish&nocache=true',
  },
  {
    id: 'tshirts',
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Graphic%20t-shirts%20hanging%20on%20a%20metal%20clothing%20rack%20against%20a%20soft%20mint%20green%20wall%2C%20sunlight%20casting%20gentle%20shadows%2C%20fresh%20modern%20streetwear%20retail%20display%20photography%20with%20clean%20airy%20mood&width=400&height=400&seq=cat-tshirts&orientation=squarish&nocache=true',
  },
  {
    id: 'jackets',
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Denim%20and%20quilted%20puffer%20jackets%20displayed%20on%20minimal%20mannequins%20in%20a%20warm%20beige%20studio%20with%20soft%20directional%20lighting%2C%20premium%20outerwear%20catalog%20photography%20in%20a%20sophisticated%20neutral%20palette&width=400&height=400&seq=cat-jackets&orientation=squarish&nocache=true',
  },
  {
    id: 'pants',
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Stacked%20folded%20jeans%20and%20tailored%20shorts%20in%20indigo%20and%20khaki%20laid%20flat%20on%20a%20light%20concrete%20surface%2C%20overhead%20flat%20lay%20composition%2C%20minimal%20menswear%20product%20photography%20with%20crisp%20clean%20styling&width=400&height=400&seq=cat-pants&orientation=squarish&nocache=true',
  },
  {
    id: 'headwear',
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Baseball%20caps%20and%20knitted%20beanies%20arranged%20on%20wooden%20shelves%20against%20a%20warm%20terracotta%20backdrop%2C%20cozy%20accessories%20display%20with%20soft%20ambient%20light%2C%20premium%20streetwear%20photography%20in%20earthy%20tones&width=400&height=400&seq=cat-headwear&orientation=squarish&nocache=true',
  },
  {
    id: 'sets',
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Matching%20two-piece%20tracksuit%20set%20in%20muted%20olive%20green%20hanging%20on%20a%20wooden%20hanger%20against%20a%20sage%20wall%2C%20minimal%20sportswear%20studio%20shot%20with%20soft%20natural%20light%2C%20contemporary%20athleisure%20catalog%20style&width=400&height=400&seq=cat-sets&orientation=squarish&nocache=true',
  },
  {
    id: 'underwear',
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Neatly%20folded%20premium%20cotton%20underwear%20in%20soft%20pastel%20colors%20on%20a%20lavender%20linen%20surface%20with%20delicate%20fabric%20texture%2C%20minimalist%20intimate%20apparel%20product%20photography%20in%20a%20bright%20airy%20mood&width=400&height=400&seq=cat-underwear&orientation=squarish&nocache=true',
  },
  {
    id: 'jersey',
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20football%20jerseys%20in%20bold%20red%20and%20blue%20hanging%20on%20a%20rail%20against%20a%20dark%20charcoal%20wall%20with%20dramatic%20side%20lighting%2C%20sportswear%20collection%20display%2C%20energetic%20and%20dynamic%20product%20shot&width=400&height=400&seq=cat-jersey&orientation=squarish&nocache=true',
  },
  {
    id: 'accessories',
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20wristwatches%2C%20sunglasses%20and%20minimal%20jewelry%20arranged%20on%20cream%20marble%20with%20soft%20reflections%2C%20luxury%20accessory%20flat%20lay%2C%20refined%20product%20photography%20with%20warm%20golden%20accent%20lighting&width=400&height=400&seq=cat-accessories&orientation=squarish&nocache=true',
  },
  {
    id: 'bags',
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Leather%20backpacks%20and%20canvas%20totes%20arranged%20against%20a%20warm%20tan%20textured%20backdrop%2C%20premium%20bag%20collection%20display%20with%20soft%20studio%20lighting%2C%20travel%20lifestyle%20product%20photography%20in%20rich%20earthy%20palette&width=400&height=400&seq=cat-bags&orientation=squarish&nocache=true',
  },
  {
    id: 'belts',
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Handcrafted%20leather%20belts%20in%20brown%20and%20black%20coiled%20elegantly%20on%20dark%20walnut%20wood%2C%20luxury%20accessory%20detail%20shot%20with%20warm%20side%20lighting%2C%20premium%20craftsmanship%20product%20photography&width=400&height=400&seq=cat-belts&orientation=squarish&nocache=true',
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottles%20with%20amber%20liquid%20on%20a%20blush%20pink%20podium%20with%20soft%20golden%20bokeh%2C%20luxury%20fragrance%20product%20photography%2C%20romantic%20warm%20ambiance%2C%20high-end%20editorial%20style&width=400&height=400&seq=cat-perfumes&orientation=squarish&nocache=true',
  },
  {
    id: 'other',
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Assorted%20fashion%20and%20lifestyle%20products%20including%20socks%2C%20wallets%20and%20sunglasses%20arranged%20on%20a%20soft%20neutral%20beige%20studio%20backdrop%2C%20mixed%20product%20flat%20lay%2C%20clean%20modern%20retail%20photography%20with%20warm%20inviting%20tones&width=400&height=400&seq=cat-other&orientation=squarish&nocache=true',
  },
];